var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "page-login" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("section", { staticClass: "login" }, [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "login-form" }, [
          _c(
            "form",
            {
              attrs: { id: "registerform" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
                keydown: function ($event) {
                  return _vm.registerForm.errors.clear($event.target.name)
                },
              },
            },
            [
              _c("h1", [
                _vm._v("Discover the most suitable investors for you!"),
              ]),
              _vm._v(" "),
              _vm.is_completed
                ? _c("div", [
                    _c("p", [
                      _vm._v(
                        "Please book a video call with us by selecting a suitable time slot in the calendar below."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("iframe", {
                      staticStyle: {
                        border: "0",
                        "max-width": "1200px",
                        height: "1130px",
                      },
                      attrs: {
                        width: "100%",
                        height: "1130",
                        border: "0",
                        frameborder: "0",
                        src: "https://calendly.com/d/4dt-7ct-5x9/introduction-call-with-proptecham-ai",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "You should have also received an email from us containing details to log into your account. Please check your spam folder if you can’t find this in your inbox."
                      ),
                    ]),
                  ])
                : _c(
                    "div",
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "first_name" } }, [
                        _vm._v(_vm._s(_vm.trans("auth.first_name"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.registerForm.first_name,
                            expression: "registerForm.first_name",
                          },
                        ],
                        attrs: { type: "text", name: "first_name" },
                        domProps: { value: _vm.registerForm.first_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.registerForm,
                              "first_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "first_name",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "last_name" } }, [
                        _vm._v(_vm._s(_vm.trans("auth.last_name"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.registerForm.last_name,
                            expression: "registerForm.last_name",
                          },
                        ],
                        attrs: { type: "text", name: "last_name" },
                        domProps: { value: _vm.registerForm.last_name },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.registerForm,
                              "last_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "last_name",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "email" } }, [
                        _vm._v(_vm._s(_vm.trans("auth.email"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.registerForm.email,
                            expression: "registerForm.email",
                          },
                        ],
                        attrs: { type: "text", name: "email" },
                        domProps: { value: _vm.registerForm.email },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.registerForm,
                              "email",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "email",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", [_vm._v("Your Company’s Name")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.registerForm.company,
                            expression: "registerForm.company",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: { value: _vm.registerForm.company },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.registerForm,
                              "company",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "company",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "20px" } }, [
                        _vm._v("Your Work Phone Number"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.registerForm.phone,
                            expression: "registerForm.phone",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text", maxlength: "50" },
                        domProps: { value: _vm.registerForm.phone },
                        on: {
                          keydown: _vm.filterInputNumber,
                          paste: _vm.filterInputPaste,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.registerForm,
                              "phone",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "block",
                            "padding-top": "5px",
                            "font-size": "14px",
                            color: "#999",
                          },
                        },
                        [_vm._v("Please also add your country code.")]
                      ),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "phone",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "20px" } }, [
                        _vm._v("Where are your company's headquarters?"),
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          label: "name",
                          "track-by": "id",
                          name: "hq_country_id",
                          id: "hq_country_id",
                          options: _vm.countries,
                          placeholder: "Please choose",
                          multiple: true,
                          "close-on-select": true,
                          "clear-on-select": false,
                          "hide-selected": true,
                          placeholder: "Please choose",
                          selectLabel: "choose",
                          selected: _vm.selected_hq_countries,
                        },
                        on: {
                          select: _vm.onHQCountrySelect,
                          remove: _vm.onHQCountryRemove,
                        },
                        model: {
                          value: _vm.selected_hq_countries,
                          callback: function ($$v) {
                            _vm.selected_hq_countries = $$v
                          },
                          expression: "selected_hq_countries",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            display: "block",
                            "padding-top": "5px",
                            "font-size": "14px",
                            color: "#999",
                          },
                        },
                        [
                          _vm._v(
                            'Start typing your country name in the box and press "choose" to select.'
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "hq_country_id",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v(
                          "From which investor do you want to raise capital from in the future (high level)?"
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        {
                          staticClass: "pta-signup-list",
                          staticStyle: { "margin-bottom": "0" },
                        },
                        [
                          _c("li", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.registerForm.investor_types,
                                  expression: "registerForm.investor_types",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                id: "c1",
                                name: "c1",
                                value: "1",
                                "true-value": [],
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.registerForm.investor_types
                                )
                                  ? _vm._i(
                                      _vm.registerForm.investor_types,
                                      "1"
                                    ) > -1
                                  : _vm._q(_vm.registerForm.investor_types, []),
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.registerForm.investor_types,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? [] : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "1",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.registerForm,
                                          "investor_types",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.registerForm,
                                          "investor_types",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.registerForm,
                                      "investor_types",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _c("label", { attrs: { for: "c1" } }, [
                              _vm._v("High-net-worth investor"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.registerForm.investor_types,
                                  expression: "registerForm.investor_types",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                id: "c2",
                                name: "c2",
                                value: "2",
                                "true-value": [],
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.registerForm.investor_types
                                )
                                  ? _vm._i(
                                      _vm.registerForm.investor_types,
                                      "2"
                                    ) > -1
                                  : _vm._q(_vm.registerForm.investor_types, []),
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.registerForm.investor_types,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? [] : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "2",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.registerForm,
                                          "investor_types",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.registerForm,
                                          "investor_types",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.registerForm,
                                      "investor_types",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _c("label", { attrs: { for: "c2" } }, [
                              _vm._v("Family Offices"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.registerForm.investor_types,
                                  expression: "registerForm.investor_types",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                id: "c3",
                                name: "c3",
                                value: "3",
                                "true-value": [],
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.registerForm.investor_types
                                )
                                  ? _vm._i(
                                      _vm.registerForm.investor_types,
                                      "3"
                                    ) > -1
                                  : _vm._q(_vm.registerForm.investor_types, []),
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.registerForm.investor_types,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? [] : false
                                  if (Array.isArray($$a)) {
                                    var $$v = "3",
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        _vm.$set(
                                          _vm.registerForm,
                                          "investor_types",
                                          $$a.concat([$$v])
                                        )
                                    } else {
                                      $$i > -1 &&
                                        _vm.$set(
                                          _vm.registerForm,
                                          "investor_types",
                                          $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1))
                                        )
                                    }
                                  } else {
                                    _vm.$set(
                                      _vm.registerForm,
                                      "investor_types",
                                      $$c
                                    )
                                  }
                                },
                              },
                            }),
                            _c("label", { attrs: { for: "c3" } }, [
                              _vm._v("Institutional Investor"),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "investor_types",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "20px" } }, [
                        _vm._v(
                          "From which main country should your ideal investor come from?"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          label: "name",
                          "track-by": "id",
                          name: "main_country_id",
                          id: "main_country_id",
                          options: _vm.countries,
                          placeholder: "Please choose",
                          multiple: true,
                          "close-on-select": true,
                          "clear-on-select": false,
                          "hide-selected": true,
                          placeholder: "Please choose",
                          selectLabel: "choose",
                          selected: _vm.selected_main_countries,
                        },
                        on: {
                          select: _vm.onMainCountrySelect,
                          remove: _vm.onMainCountryRemove,
                        },
                        model: {
                          value: _vm.selected_main_countries,
                          callback: function ($$v) {
                            _vm.selected_main_countries = $$v
                          },
                          expression: "selected_main_countries",
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "main_country_id",
                        },
                      }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "pta-signup-h3" }, [
                        _vm._v("ABOUT YOUR FUND / DEAL:"),
                      ]),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v("In which Asset Class are you investing?"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.registerForm.fund_category_id,
                              expression: "registerForm.fund_category_id",
                            },
                          ],
                          staticClass: "custom-select",
                          attrs: { id: "continent_2_id" },
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.registerForm,
                                  "fund_category_id",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.getFundTypes,
                            ],
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Please choose the fund category"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.fund_categories, function (fund_category) {
                            return _c(
                              "option",
                              { domProps: { value: fund_category.id } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(fund_category.name) +
                                    "\n              "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "fund_category_id",
                        },
                      }),
                      _vm._v(" "),
                      _vm.fund_types_cur && _vm.registerForm.fund_category_id
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.registerForm.fund_type_id,
                                  expression: "registerForm.fund_type_id",
                                },
                              ],
                              staticClass: "custom-select",
                              staticStyle: { "margin-top": "10px" },
                              attrs: { id: "fund_type_id" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.registerForm,
                                    "fund_type_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("Please choose the fund type"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.fund_types_cur, function (fund_type) {
                                return _c(
                                  "option",
                                  { domProps: { value: fund_type.id } },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(fund_type.name) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.registerForm.fund_category_id
                        ? _c("show-error", {
                            attrs: {
                              "form-name": _vm.registerForm,
                              "prop-name": "fund_type_id",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "30px" } }, [
                        _vm._v("Where are you investing primarily?"),
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          label: "name",
                          "track-by": "id",
                          name: "asset_country_id",
                          id: "asset_country_id",
                          options: _vm.countries,
                          placeholder: "Please choose",
                          multiple: true,
                          "close-on-select": true,
                          "clear-on-select": false,
                          "hide-selected": true,
                          placeholder: "Please choose",
                          selectLabel: "choose",
                          selected: _vm.selected_asset_countries,
                        },
                        on: {
                          select: _vm.onAssetCountrySelect,
                          remove: _vm.onAssetCountryRemove,
                        },
                        model: {
                          value: _vm.selected_asset_countries,
                          callback: function ($$v) {
                            _vm.selected_asset_countries = $$v
                          },
                          expression: "selected_asset_countries",
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.registerForm,
                          "prop-name": "asset_country_id",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clear" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "login-form-checkboxes" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.registerForm.is_fund,
                              expression: "registerForm.is_fund",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "is_fund",
                            id: "is_fund",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.registerForm.is_fund)
                              ? _vm._i(_vm.registerForm.is_fund, null) > -1
                              : _vm.registerForm.is_fund,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.registerForm.is_fund,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.registerForm,
                                      "is_fund",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.registerForm,
                                      "is_fund",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.registerForm, "is_fund", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "is_fund" } }, [
                          _vm._v(
                            "Are you considering setting up a fund? (Tick for Yes)"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.registerForm.newsletter,
                              expression: "registerForm.newsletter",
                            },
                          ],
                          attrs: {
                            type: "checkbox",
                            name: "newsletter",
                            id: "newsletter",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.registerForm.newsletter)
                              ? _vm._i(_vm.registerForm.newsletter, null) > -1
                              : _vm.registerForm.newsletter,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.registerForm.newsletter,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.registerForm,
                                      "newsletter",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.registerForm,
                                      "newsletter",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.registerForm, "newsletter", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "newsletter" } }, [
                          _vm._v(
                            "(Optional) Sign up to our Newsletter (you can unsubscribe at any time)."
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button",
                          attrs: { disabled: _vm.is_send, type: "submit" },
                        },
                        [_vm._v("PROCEED TO BOOK A CALL WITH US")]
                      ),
                    ],
                    1
                  ),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "clear" }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("div", { staticClass: "content" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            staticClass: "header-logo",
            attrs: { src: "/images/logo.svg" },
          }),
        ]),
        _vm._v(" "),
        _c(
          "a",
          { staticClass: "header-button-si", attrs: { href: "/login" } },
          [_vm._v("Sign In")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Our AI provides tailored investor insights that match your specific requirements."
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n                Simply fill out the brief questionnaire below to obtain your personalised investor list at no cost.\n              "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "login-hiw" }, [
      _c("h2", [_vm._v("Here’s how it works")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("i", [_vm._v("1")]),
          _c("h3", [_vm._v("Complete our first questionnaire")]),
          _c("p", [
            _vm._v(
              "Tell us more about your investor preferences and your investment offering"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", [_vm._v("2")]),
          _c("h3", [_vm._v("Get some free, suitable investor insights")]),
          _c("p", [_vm._v("based on the information submitted")]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("i", [_vm._v("3")]),
          _c("h3", [_vm._v("Book a video call with one of our experts")]),
          _c("p", [
            _vm._v("Our team will review your offering and give you a quote"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clear" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }